import { Helmet } from "react-helmet";
import products from "../data/products";
import { useState, useEffect } from "react";

function Products() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        padding: isMobile ? "30px 15px" : "40px 20px",
        color: "white",
        background: "#2B2B2B",
      }}
    >
      <Helmet>
        <title>Our Products - G Bond</title>
      </Helmet>

      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ color: "#FFC107", fontSize: isMobile ? "26px" : "36px" }}>
          Our Products
        </h1>

        <p style={{ fontSize: isMobile ? "14px" : "16px" }}>
          High-quality tyre repair materials and rubber compounds
        </p>
      </div>

      {/* PRODUCT LIST */}
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        {products.map((item) => {
          const images = Array.isArray(item.images)
            ? item.images
            : [item.images];

          return (
            <div
              key={item.id}
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: "25px",
                marginBottom: "30px",
                padding: isMobile ? "15px" : "20px",
                background: "#1C1C1C",
                borderRadius: "12px",
              }}
            >
              {/* IMAGE */}
              <div style={{ flex: "1" }}>
                <img
                  src={images[0]}
                  alt={item.name}
                  style={{
                    width: "100%",
                    height: isMobile ? "200px" : "250px",
                    objectFit: "contain",
                    borderRadius: "10px",
                    background: "#1C1C1C",
                    padding: "10px",
                  }}
                />
              </div>

              {/* DETAILS */}
              <div style={{ flex: "2" }}>
                <h2 style={{ color: "#FFC107", fontSize: isMobile ? "20px" : "26px" }}>
                  {item.name}
                </h2>

                <p
                  style={{
                    marginTop: "10px",
                    lineHeight: "1.7",
                    fontSize: isMobile ? "14px" : "15px",
                  }}
                >
                  {item.description}
                </p>

                <a
                  href={`https://wa.me/917412885533?text=I am interested in ${item.name}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button style={waBtn}>
                    Enquire on WhatsApp
                  </button>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const waBtn = {
  marginTop: "15px",
  padding: "12px 20px",
  background: "#25D366",
  border: "none",
  color: "white",
  cursor: "pointer",
  borderRadius: "5px",
};

export default Products;